import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const ancillaryGroundServicesImport = importReducer(EImportEntity.ANCILLARY_GROUND_SERVICES);
